<template>
  <header
    class="header glass"
    v-if="
      routeLayout.isSearchHeader && proxy.$route?.path?.includes('memorial') && !proxy.$route?.path?.includes('select')
    "
  >
    <!--배경 이미지 들어갈 시 glass 클래스 추가-->
    <div class="inner">
      <div class="left">
        <button class="header-btn" @click="fnBack"><i class="ico-hd-arrow-left-gr90"></i></button>
      </div>
      <h1 class="ttl">{{ routeLayout.titleName }}</h1>
    </div>
  </header>
  <header class="header transpar" v-if="routeLayout.isSearchHeader">
    <div class="inner">
      <label class="label search">
        <input
          type="text"
          :placeholder="
            currentPath === SEARCH_TYPE_URL.MEMORIAL
              ? '추모관을 검색해 주세요'
              : '고인 또는 고인 가족 이름을 입력해 주세요'
          "
          v-model="state.searchText"
          @keyup.enter="fnSearch"
          @click="closeModal"
        />
        <button class="btn-search" @click="fnSearch"></button>
      </label>
      <label class="label" v-if="routeLayout.isFilter">
        <button class="select" @click="fnFilterModal">{{ state.searchName }}</button>
      </label>
    </div>
  </header>
</template>

<script setup>
import { computed, getCurrentInstance, nextTick, onUpdated, reactive, watch } from 'vue';
import { modalList } from '@/common/utils/ModalState';
import { SEARCH_TYPE_URL, MODAL_TYPE, MEMORIAL_SEARCH_TYPE, KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import { isStringIncludeValid } from '@/common/utils/module/ValidSupport';
import router from '@/router';
import store from '@/store';
import { replace } from 'lodash';
const { proxy } = getCurrentInstance();
const routeLayout = computed(() => store.getters['layout/getRouteLayout']);
const currentPath = computed(() => proxy.$route.path);
const userData = computed(() => store.getters['user/getUserData']);
const isMore = computed(() => store.getters['memorial/getIsMore']);

const state = reactive({
  searchType: MEMORIAL_SEARCH_TYPE.DEAD_NAME.value,
  searchName: MEMORIAL_SEARCH_TYPE.DEAD_NAME.key,
  searchText: '',
  searchFlag: false
});

onUpdated(async () => {
  if (isMore.value) {
    state.searchType = MEMORIAL_SEARCH_TYPE.NAME.value;
    state.searchName = MEMORIAL_SEARCH_TYPE.NAME.key;
    state.searchText = userData.value.name;
    store.commit('memorial/setIsMore');
    await fnSearch();
  }
});
watch(
  () => router.currentRoute.value,
  (to, from) => {
    if (from.meta.expression === KEEP_ALIVE_OBJECT.MEMORIAL_SELECT.expression) return;
    if (!isMore.value && to.meta.expression !== from.meta.expression) {
      fnSearchInit();
    }
  }
);

const closeModal = () => {
  store.dispatch('layout/closeModalComponent', 0);
};

const fnBack = () => {
  router.go(-1);
};

const fnSearchInit = () => {
  state.searchType = MEMORIAL_SEARCH_TYPE.DEAD_NAME.value;
  state.searchName = MEMORIAL_SEARCH_TYPE.DEAD_NAME.key;
  state.searchText = '';
  state.searchFlag = false;
};

const fnSearch = async () => {
  state.searchFlag = true;
  if (isStringIncludeValid(currentPath.value, SEARCH_TYPE_URL.MEMORIAL)) {
    store.commit('memorial/initMemorials', true);
    await store.dispatch('memorial/getMemorials', state);
  } else {
    delete state.searchType;
    state.searchName = '';
    store.commit('funeral/initFunerals', true);
    await store.dispatch('funeral/getFunerals', state);
  }
};

const fnFilterModal = () => {
  const defaultValue = {
    value: state.searchType,
    key: state.searchName
  };

  const payload = {
    component: modalList.RADIO_CONTENT_MODAL,
    data: {
      fnCallBack: data => {
        state.searchType = data.value;
        state.searchName = data.key;
      },
      defaultValue: defaultValue || MEMORIAL_SEARCH_TYPE.DEAD_NAME,
      modalType: MODAL_TYPE.SEARCH,
      // 260902 '등록 교회'(CHURCH) 제외 — MemorialDao.searchByKeyword 가 CHURCH 를 DSL.condition(false)로
      //   떨어뜨려 구조적으로 영구 0건이고, 결과 카드를 눌러도 /memorial/church/{churchNo} 는 BE 매핑이 없어
      //   운영에서 500 이 난다(tblMemorialDead 에 churchNo 컬럼 자체가 없다).
      //   교회 검색은 동작이 검증된 /cry/memorial/search 의 '교회명' 필터를 쓴다.
      //   상수(MEMORIAL_SEARCH_TYPE.CHURCH)는 다른 소비처가 값 비교에 쓰므로 지우지 않고 노출만 막는다.
      contents: Object.entries(MEMORIAL_SEARCH_TYPE).filter(
        ([, v]) => v.value !== MEMORIAL_SEARCH_TYPE.CHURCH.value
      )
    }
  };
  store.dispatch('layout/pushModalComponent', payload);
};
</script>

<style scoped></style>
